<script>
import Card from "./Card";

export default {
  props: {
    cycles: {
      type: Array,
      required: true
    }
  },
  components: {
    Card
  }
};
</script>

<template>
  <section>
    <div class="no-cycles" v-if="!cycles.length">Não há ciclos à serem mostrados nessa assinatura.</div>
    <card v-for="cycle in cycles" :key="cycle.id" :cycle="cycle" />
  </section>
</template>

<style scoped>
section {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.no-cycles {
  color: #555;
  font-size: 14px;
}

@media (max-width: 768px) {
  section {
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Subscriptions/Subscription/Cycles/Index.vue